import React, { useEffect, useState } from "react";
import LecturesCard from "./LecturesCard";
const Lectures = () => {
  const [lectures, setLectures] = useState([]);
  //   load data
  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/lecture/getlecture`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data.length) {
          setLectures(data?.data);
        }
      });
  }, []);
  return (
    <div className="bg-white">
      <div className=" lg:w-10/12 w-11/12 py-10 mx-auto min-h-screen ">
        <div>
          <h1 className="  text-secondary text-3xl font-bold text-center">
            Lectures
          </h1>
        </div>

        <div className=" grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10 mt-10 ">
          {lectures?.reverse()?.map((lecture) => (
            <LecturesCard key={lecture?.key} lecture={lecture} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Lectures;
